import { languages, type TranslatableField } from '../lib/languages.ts'

export function traitHasTranslations({
  text,
  translations,
}: {
  text: string
  translations?: TranslatableField
}) {
  return (
    !!translations &&
    translations.length === languages.length &&
    translations.some((t) => t.lang === 'en' && t.text === text) &&
    translations.every((t) => languages.includes(t.lang) && !!t.text && t.text.length > 1)
  )
}
